import { useState, useEffect } from 'react';
import throttle from 'lodash.throttle';

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<{
    width: undefined | number;
    height: undefined | number;
  }>({
    width: undefined,
    height: undefined,
  });

  const isXs = windowSize.width && windowSize.width < 601 ? true : false;

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      window.innerWidth &&
      window.innerHeight
    ) {
      const handleResize = () => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };

      const throttledResizeHandler = throttle(handleResize, 500);

      window.addEventListener('resize', throttledResizeHandler);

      return () => window.removeEventListener('resize', throttledResizeHandler);
    }
  }, []);
  return { isXs };
};

export default useWindowSize;
